/* @flow */
import React, { Component } from 'react'
import styled from 'styled-components'
import Link from '../../utils/Link'
import { type RegionPickerTriggerProps } from './Types'

const StyledRegionPickerTrigger = styled(Link)`
  background: url(${props => props.theme.jobs.arrowUrl}) no-repeat;
  background-position: 0 -24px;
  color: ${props => props.theme.jobs.color};
  cursor: pointer;
  font-size: 13px;
  line-height: 24px;
  padding-left: 14px;
  text-decoration: underline;
  &.open {
    background-position: 0 0;
  }
  &:hover {
    background-position: 0 -72px;
    color: ${props => props.theme.jobs.colorHover};
  }
  &.open:hover {
    background-position: 0 -48px;
  }
`

export default class RegionPickerTrigger extends Component<RegionPickerTriggerProps> {
  render () {
    const {
      activeRegion,
      isOpen,
      onClick
    } = this.props

    return (
      <StyledRegionPickerTrigger
        className={isOpen ? 'open' : ''}
        href='#'
        onClick={event => {
          event.preventDefault()
          onClick()
        }}
      >
        {activeRegion.caption}
      </StyledRegionPickerTrigger>
    )
  }
}
